module.exports = __webpack_public_path__ + "img/mitbach_yes.0e9ee29f.png";